module.exports = __webpack_public_path__ + "static/media/killer-bee-armor.3a468878.png";